<template>
  <div id="video-overlay" class="ui center aligned middle aligned padded grid">
    <div class="eight wide column">
      <Thumbnail :syncguid="syncguid" size="fluid" @play="$emit('play')" />
      <div class="ui basic fitted segment">
        <button v-if="hasQuiz" class="ui green button" @click="$emit('showQuizModal')">Take Quiz</button>
        <button class="ui button" :class="hasQuiz ? 'grey' : 'green'" @click="$emit('exit')">Save &amp; Exit</button>
      </div>
    </div>
  </div>
</template>

<script>
import Thumbnail from '@/components/profile/Thumbnail';

export default {
  name: 'Overlay',
  components: {
    Thumbnail,
  },
  computed: {
    syncguid() {
      return this.$route.params.syncguid;
    },
    hasQuiz() {
      return Object.keys(this.$store.getters.contentById(this.syncguid).quiz).length > 0;
    },
  },
};
</script>

<style lang="less">
#video-overlay {
  position: absolute;
  display: flex;
  flex-direction: row;
  align-items: center;
  top: 0;
  left: 0;
  height: 100%;
  width: calc(100% + 6px);
  background: #000000;
  z-index: 1000;
  .ui.button {
    margin-left: 10px;
    &:not(:first-child) {
      margin-top: 5px;
    }
  }
  .ui.image .playButton {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    margin: 0;
  }
}
</style>
